"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var chevron_left_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_left"));
var chevron_right_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_right"));
var LftIconBase_1 = __importDefault(require("../LftIconBase"));
var S = __importStar(require("./LftCarousel.styles"));
var LftCarousel = function (_a) {
    var _b, _c, _d, _e;
    var bgColor = _a.bgColor, buttonLeftDataElement = _a.buttonLeftDataElement, buttonLeftDataInfo = _a.buttonLeftDataInfo, buttonLeftDisabled = _a.buttonLeftDisabled, buttonRightDataElement = _a.buttonRightDataElement, buttonRightDataInfo = _a.buttonRightDataInfo, buttonRightDisabled = _a.buttonRightDisabled, _f = _a.currentItem, currentItem = _f === void 0 ? 0 : _f, dataTestId = _a.dataTestId, id = _a.id, _g = _a.quantityOfItems, quantityOfItems = _g === void 0 ? 4 : _g, lftNext = _a.lftNext, lftPrevious = _a.lftPrevious;
    var _h = (0, react_1.useState)(currentItem), _currentItem = _h[0], setCurrentItem = _h[1];
    (0, react_1.useEffect)(function () {
        setCurrentItem(currentItem);
    }, [currentItem]);
    var firstItem = function () { return _currentItem === 0; };
    var lastItem = function () { return _currentItem === quantityOfItems - 1; };
    var incrementCurrentIndex = (0, react_1.useCallback)(function () {
        if (_currentItem < quantityOfItems - 1) {
            setCurrentItem(_currentItem + 1);
        }
    }, [_currentItem, quantityOfItems]);
    var decrementCurrentIndex = (0, react_1.useCallback)(function () {
        if (_currentItem > 0) {
            setCurrentItem(_currentItem - 1);
        }
    }, [_currentItem]);
    var _internalLftNext = (0, react_1.useCallback)(function (e) {
        incrementCurrentIndex();
        lftNext(e);
    }, [incrementCurrentIndex, lftNext]);
    var _internalLftPrevious = (0, react_1.useCallback)(function (e) {
        decrementCurrentIndex();
        lftPrevious(e);
    }, [decrementCurrentIndex, lftPrevious]);
    var renderPoints = function () {
        var points = [];
        for (var i = 0; i < quantityOfItems; i++) {
            if (i === _currentItem) {
                points.push((0, jsx_runtime_1.jsx)(S.CarouselActivatedStyled, { bgColor: bgColor }, i));
            }
            else {
                points.push((0, jsx_runtime_1.jsx)(S.CarouselDefaultStyled, { bgColor: bgColor }, i));
            }
        }
        return points;
    };
    var _shouldDisableNext = function () { return lastItem() || buttonRightDisabled; };
    var _shouldDisablePrevious = function () { return firstItem() || buttonLeftDisabled; };
    if (buttonLeftDataElement) {
        if (buttonLeftDataElement.includes('_')) {
            if (typeof window !== 'undefined' && (((_b = window.location.href) === null || _b === void 0 ? void 0 : _b.indexOf("localhost")) > -1 || ((_c = window.location.href) === null || _c === void 0 ? void 0 : _c.indexOf("dev")) > -1)) {
                console.warn('Não é necessário mais colocar o prefixo no atributo buttonLeftDataElement');
            }
        }
        else {
            buttonLeftDataElement = "button_" + buttonLeftDataElement;
        }
    }
    if (buttonRightDataElement) {
        if (buttonRightDataElement.includes('_')) {
            if (typeof window !== 'undefined' && (((_d = window.location.href) === null || _d === void 0 ? void 0 : _d.indexOf("localhost")) > -1 || ((_e = window.location.href) === null || _e === void 0 ? void 0 : _e.indexOf("dev")) > -1)) {
                console.warn('Não é necessário mais colocar o prefixo no atributo buttonRightDataElement');
            }
        }
        else {
            buttonRightDataElement = "button_" + buttonRightDataElement;
        }
    }
    return ((0, jsx_runtime_1.jsxs)(S.CarouselStyled, __assign({ id: id, "data-lift": "lft-carousel", "data-testid": dataTestId ? dataTestId : id && id }, { children: [(0, jsx_runtime_1.jsx)(S.CarouselPointsStyled, __assign({ bgColor: bgColor }, { children: renderPoints() }), void 0), (0, jsx_runtime_1.jsxs)(S.CarouselArrowsStyled, __assign({ bgColor: bgColor }, { children: [(0, jsx_runtime_1.jsx)(S.CarouselButtonStyled, __assign({ "aria-label": "Navegar para o anterior", bgColor: bgColor, "data-element": buttonLeftDataElement, "data-info": buttonLeftDataInfo, disabled: _shouldDisablePrevious(), tabIndex: _shouldDisablePrevious() ? -1 : 0, onClick: _internalLftPrevious }, { children: (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { alt: 'Navegar para o anterior', icon: chevron_left_1.default, size: "md" }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(S.CarouselButtonStyled, __assign({ "aria-label": "Navegar para o pr\u00F3ximo", bgColor: bgColor, "data-element": buttonRightDataElement, "data-info": buttonRightDataInfo, disabled: _shouldDisableNext(), tabIndex: _shouldDisableNext() ? -1 : 0, onClick: _internalLftNext }, { children: (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { alt: 'Navegar para o próximo', icon: chevron_right_1.default, size: "md" }, void 0) }), void 0)] }), void 0)] }), void 0));
};
exports.default = LftCarousel;
